<ps-ui-modal>
  <ps-ui-modal-title>
    <h2 psUiModalTitle>Manage Subscribers</h2>
  </ps-ui-modal-title>
  <ps-ui-modal-body class="subscriber-modal-body">
    <div class="row">
      <div class="col-md-4 add-subscriber">
        <form [formGroup]="form">
          <div class="row">
            <div class="col-md-12">
              <label class="add-subscriber-title">Add Subscriber</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                class="form-control"
                formControlName="email"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label>Timezone</label>
              <ps-ui-select-dropdown
                class="subscriber-timezone-dropdown"
                id="timezone_position"
                [labelNone]="'Select Timezone'"
                labelAlignment="start"
                [dropdownItems]="timezones"
                [field]="'name'"
                (selectedItem)="selectTimeZone($event)"
                formControlName="timezone"
              >
              </ps-ui-select-dropdown>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p class="form-footnote">
                <small>
                  Reports will be sent out twice a day at 8am and 4pm based on
                  your timezone selected.
                </small>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button
                type="button"
                class="clear-btn btn btn-primary pull-right ms-2"
                psUiButton
                (click)="close('save')"
              >
                SAVE
              </button>
              <button
                type="button"
                psUiButton
                color="secondary"
                (click)="close()"
                class="cancle-btn btn btn-default pull-right"
              >
                CANCEL
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-8 subscribers-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="col-4">Email</th>
              <th class="col-2">Time Zone</th>
              <th class="col-2 text-center">Created</th>
              <th class="col-1 text-center"><i class="fa fa-trash"></i></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="subscribers.length; else noSubscriber">
              <tr *ngFor="let subscriber of subscribers">
                <td>{{ subscriber.email }}</td>
                <td>{{ subscriber.timezone }}</td>
                <td class="text-center">
                  {{ subscriber.created | date : 'dd/MM/yyyy' }}
                </td>
                <td class="text-center">
                  <a (click)="deleteSubscriber(subscriber)"
                    ><i class="fa fa-times"></i
                  ></a>
                </td>
              </tr>
            </ng-container>
            <ng-template #noSubscriber>
              <tr>
                <td colspan="4">
                  <div class="alert alert-light text-center">
                    No Email Subscribers
                  </div>
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </ps-ui-modal-body>
</ps-ui-modal>
